// Statuses that mean "not yet fully paid" — used by Dashboard, SalesManagement
// and any other admin surface that reports on unpaid tickets. Keep the three
// consumers in sync (backend admin.py has its own literal list — mirror there
// if this ever changes).
export const PENDING_STATUSES = ["pending", "installments"];

export const isPendingStatus = (status) => PENDING_STATUSES.includes(status);
